import React from 'react'

export const VerticalVideoPlayer: React.FC = () => null
